export { default } from "./Pickup.page";
